// extracted by mini-css-extract-plugin
module.exports = {"trigger":"tooltip_trigger__ymgqM","tooltip":"tooltip_tooltip__3_ty_","body":"tooltip_body__2I_rS","toggle_view":"tooltip_toggle_view__1NqZJ"};